import {assert} from 'Asserts';
import {PipelineStepDataKind} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStep, pipelineStepRawDataIsKind} from 'pipelines/PipelineTypes';

/**
 * Find the output step data name and raw data index for a scratch plate on its source step.
 */
export function getScratchPlateOutputReference(
  step: PipelineStep,
  scratchPlateId: string
): {stepDataName: string; fromStepDataIndex: number} | null {
  for (const stepData of step.outputStepDatas) {
    const fromStepDataIndex = stepData.rawDatas.findIndex(
      (rawData) =>
        pipelineStepRawDataIsKind(rawData, PipelineStepDataKind.PLATE) && rawData.id === scratchPlateId
    );
    if (fromStepDataIndex >= 0) {
      return {stepDataName: stepData.name, fromStepDataIndex};
    }
  }
  return null;
}

export interface ScratchPlateOutputReference {
  sourceStepId: string;
  stepDataName: string;
  fromStepDataIndex: number;
}

export function findScratchPlateOutputReferenceOnStep(
  steps: ReadonlyArray<PipelineStep>,
  sourceStepId: string,
  scratchPlateId: string
): ScratchPlateOutputReference {
  const sourceStep = steps.find((step) => step.id === sourceStepId);
  assert(sourceStep != null, 'Expected to find scratch plate source step', {
    stepId: sourceStepId,
  });
  const reference = getScratchPlateOutputReference(sourceStep, scratchPlateId);
  assert(reference != null, 'Expected to find scratch plate output reference', {
    stepId: sourceStepId,
    scratchPlateId,
  });

  return {
    sourceStepId,
    stepDataName: reference.stepDataName,
    fromStepDataIndex: reference.fromStepDataIndex,
  };
}
